import { Model } from '@vuex-orm/core'

export class SubjectBookable extends Model {
  static entity = 'subjectBookable'
  static primaryKey = ['subject_id', 'bookable_id']

  static fields () {
    return {
      subject_id: this.attr(null),
      bookable_id: this.attr(null)
    }
  }
}

export default SubjectBookable
